<template>
    <div class="wrap flex-column-center">
        <div class="title">操作视频</div>
        <div class="wrapBox">
            <div class="video" id="mse"></div>
        </div>

    </div>
</template>
<script>
import urlJson from '../url.json';
import Player from 'xgplayer'
import HlsJsPlyaer from 'xgplayer-hls.js';
export default {
    data() {
        return {
            videoPlayer: null,
            urlJson,
            videolist: {
                '北京': {
                    '1': '/video/京蒙教育协作智慧平台使用说明_M3U8/京蒙教育协作智慧平台使用手册（面向北京市区级教育部门管理者）/index.m3u8',
                    '2': '/video/京蒙教育协作智慧平台使用说明_M3U8/京蒙教育协作智慧平台使用说明（面向北京学校管理者）/index.m3u8',
                    '3': '/video/京蒙教育协作智慧平台使用说明_M3U8/京蒙教育协作智慧平台使用手册（面向北京学校教师）/index.m3u8',
                },
                '内蒙古': {
                    '1': '/video/内蒙/平台使用视频（面向内蒙古各盟市旗县教育部门管理者）/index.m3u8',
                    '2': '/video/内蒙/平台使用视频（面向内蒙古学校管理者）/index.m3u8',
                    '3': '/video/内蒙/平台使用视频（面向内蒙古学校教师）/index.m3u8',
                }
            }
        }
    },
    methods: {

    },
    mounted() {
        this.$nextTick(function () {
            this.videoPlayer = new HlsJsPlyaer({
                el: document.querySelector("#mse"),
                url: this.videolist[this.$route.query.fileName][this.$route.query.fileIndex],
                width: "100%",
                height: "100%",
                volume: 0.6, // 初始音量
                autoplay: true, // 自动播放
            })
        })
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.state.user.token == null ? next('/home/page') : next();
        })
    },
};
</script>
<style lang='less' scoped>
.wrap {
    width: 100vw;
    height: 100vh;

    .wrapBox {
        width: 70vw;
        height: 85vh;
    }

    .title {
        font-size: 27px;
        font-weight: bold;
        margin-bottom: 25px;
        letter-spacing: 4px;
    }
}
</style>